// extracted by mini-css-extract-plugin
export default {"badge__container":"styles_badge__container__+3ruQ","badge__text--count":"styles_badge__text--count__ZcprF"};